import { BaseService, Service } from "/@/cool";

@Service("modelExpress")
class ModelExpress extends BaseService {
	availableByAddress(params: any) {
		return this.request({
			url: "/availableByAddress",
			method: "POST",
			data: { ...params }
		});
	}
}

export default ModelExpress;
